import { render, staticRenderFns } from "./FormInputRadioRating.vue?vue&type=template&id=6867303d&"
import script from "./FormInputRadioRating.vue?vue&type=script&lang=js&"
export * from "./FormInputRadioRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6867303d')) {
      api.createRecord('6867303d', component.options)
    } else {
      api.reload('6867303d', component.options)
    }
    module.hot.accept("./FormInputRadioRating.vue?vue&type=template&id=6867303d&", function () {
      api.rerender('6867303d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputRadioRating.vue"
export default component.exports